import { History, BadgeCheck } from "lucide-react";

const fmt = (iso) => new Date(iso).toLocaleString("en-IN", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });

export default function ProjectHistoryPanel({ history }) {
  const rows = [...(history || [])].sort((a, b) => (b.at || "").localeCompare(a.at || ""));
  return (
    <div className="border border-black/10 bg-white rounded-2xl lg:col-span-3" data-testid="project-history-panel">
      <div className="px-4 py-3 border-b border-black/10 label-caps flex items-center gap-2 text-royal-800"><History size={12} /> Project History</div>
      <ol className="p-4 space-y-3">
        {rows.map((h) => {
          const isApproval = h.type === "client_approved";
          const isChange = h.type === "changes_requested";
          return (
            <li key={h.id} data-testid={`history-${h.type}-${h.id}`} className={`border-l-2 pl-3 ${isApproval ? "border-emerald-500" : isChange ? "border-orange-400" : "border-royal-700/20"}`}>
              <div className={`text-sm ${isApproval ? "font-semibold text-emerald-700 inline-flex items-center gap-1" : isChange ? "font-semibold text-orange-800 whitespace-pre-wrap" : ""}`}>{isApproval && <BadgeCheck size={14} />}{h.label}</div>
              <div className="text-xs text-neutral-500 font-mono-tight">
                {isApproval ? <>Approved on <span data-testid="history-approval-date">{new Date(h.at).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" })}</span> at <span data-testid="history-approval-time">{new Date(h.at).toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit" })}</span></> : fmt(h.at)}
                {h.by ? ` · ${h.by}` : ""}
              </div>
            </li>
          );
        })}
        {rows.length === 0 && <li className="text-sm text-neutral-500">No history recorded yet.</li>}
      </ol>
    </div>
  );
}
